/* unplugin-vue-components disabled */import script from "./JudgeTableBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./JudgeTableBlock.vue?vue&type=script&setup=true&lang=ts"

import "./JudgeTableBlock.vue?vue&type=style&index=0&id=376f7598&scoped=true&lang=less"
import "./JudgeTableBlock.vue?vue&type=style&index=1&id=376f7598&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-376f7598"]])

export default __exports__